import { render, staticRenderFns } from "./AdminLessons.vue?vue&type=template&id=50e136b5&scoped=true"
import script from "./AdminLessons.vue?vue&type=script&lang=js"
export * from "./AdminLessons.vue?vue&type=script&lang=js"
import style0 from "./AdminLessons.vue?vue&type=style&index=0&id=50e136b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e136b5",
  null
  
)

export default component.exports